export const TOPIC_TYPE_SUBJECT = 'subject'
export const TOPIC_TYPE_GRADE = 'grade'

export const ASSIGNMENT_TYPE = {
  EXAM: 'exam',
  HOMEWORK: 'homework',
}

export const EXAM_FORMATS = {
  DEFAULT: 'default',
  PDF: 'pdf',
}

export function resolveUnitType(assignmentType, examFormat = EXAM_FORMATS.DEFAULT) {
  if (assignmentType === ASSIGNMENT_TYPE.HOMEWORK) return 'homework'
  if (examFormat === EXAM_FORMATS.PDF) return 'exercise'
  return 'test'
}

// unit.type -> loại bài badge (label key + color) for Kho bài giao
export const UNIT_TYPE_BADGE = {
  test: { key: 'TYPE_TEST', color: 'amber' },
  exercise: { key: 'TYPE_EXERCISE', color: 'amber' },
  homework: { key: 'TYPE_HOMEWORK', color: 'green' },
}
